import { Star } from 'lucide-react'
import { IconToggle } from '@components/IconToggle.tsx'

type Props = {
	on: boolean
	onChange: (next: boolean) => void
}

// Header-left slide switch: off shows the normal category board, on collapses
// it to a single priority-only column. The star rides inside the knob and
// lights up when on — no label needed.
export const PriorityToggle = ({ on, onChange }: Props) => (
	<IconToggle
		on={on}
		onChange={onChange}
		icon={Star}
		ariaLabel="Priority only"
	/>
)
